<template>
  <div style="margin: auto">
    <div v-if="share && !loading">
      <div class="view-health-records" v-if="share.scope === 'cancer_card:read'">
        View Cancer Summary
      </div>
      <div class="view-health-records" v-else>View Health Profile</div>
    </div>
    <div v-if="share && !loading">
      <div class="account-create" v-if="share.expiry">
        Create an account for long-term access, or view as a guest until
        <strong>{{ new Date(share.expiry).toDateString() }}</strong
        >.
      </div>
      <div class="account-create" v-else>
        Create an account for long-term access, or view as a guest.
      </div>
      <div class="btn-wrapper">
        <Button
          label="Cancel"
          :buttonColor="'#128279'"
          fontColor="#ffffff"
          @click="gotoCiitizen"
          class="btn-margins"
          size="small"
        />
        <Button
          label="View as Guest"
          :buttonColor="share ? '#128279' : '#C9CBD5'"
          fontColor="#ffffff"
          @click="viewAsGuest"
          class="btn-margins"
          :disabled="!share"
        />
        <Button
          v-if="share.granteeInfo || share.grantee"
          label="Login"
          :buttonColor="share ? '#128279' : '#C9CBD5'"
          fontColor="#ffffff"
          @click="$router.push({ name: 'login' })"
          class="btn-margins"
          size="large"
          :disabled="!share"
        />
        <Button
          v-else
          label="Create an Account"
          :buttonColor="share ? '#128279' : '#C9CBD5'"
          fontColor="#ffffff"
          @click="moveToOnBoarding"
          class="btn-margins"
          size="large"
          :disabled="!share"
        />
      </div>
    </div>
    <div v-else-if="!loading">
      <div class="no-access">Access Denied</div>
      <Button
        label="About Ciitizen"
        buttonColor="#fff"
        fontColor="#202124"
        @click="gotoCiitizen"
        class="btn-margins"
        size="small"
        :outlined="true"
      />
      <Button
        label="Login"
        buttonColor="#128279"
        fontColor="#ffffff"
        @click="$router.push({ name: 'login' })"
        class="btn-margins"
      />
    </div>
    <progress-loader v-if="loading" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { Button } from '@ciitizen/component-library'
import { onboardingUrl, PATIENT_APP_URL } from 'config'

export default {
  name: 'external-share',
  computed: {
    ...mapState({
      share: state => state.login.share,
      DocumentOnly: state => state.login.DocumentOnly,
      fullProfile: state => state.login.fullProfile,
      CancerSummary: state => state.login.CancerSummary,
      ImagingStudy: state => state.login.ImagingStudy
    })
  },
  components: {
    Button
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    ...mapActions(['shareDetailWithIdAndToken', 'redirectToOnboarding']),
    gotoCiitizen() {
      window.open('https://www.ciitizen.com/')
    },
    viewAsGuest() {
      if (this.$redirectToPatientAppFlag) {
        return (window.location.href = `${PATIENT_APP_URL}/shared/${this.share.sharingId}`)
      }

      const email = this.share.grantorMeta.email
      localStorage.removeItem('showCancerSummary')
      let pathName = ''
      let query = ''

      if (this.fullProfile) {
        const isSharedHIEUser =
          email && email.length ? email.includes('+hie') && email.endsWith('@invitae.com') : false
        isSharedHIEUser
          ? (pathName = '/shared/' + this.share.sharingId + '/summary')
          : (pathName = '/shared/' + this.share.sharingId + '/records')
      } else if (this.CancerSummary && this.DocumentOnly) {
        pathName = '/sharedRecords/' + this.share.sharingId + '/records'
        localStorage.setItem('shareType', 'cd')
      } else if (this.ImagingStudy) {
        pathName = '/sharedRecords/' + this.share.sharingId + '/records'
        query = { viewDicom: true }
      } else if (this.CancerSummary) {
        pathName = '/s/' + this.share.sharingId + '/cancer'
      } else if (this.DocumentOnly) {
        pathName = '/sharedRecords/' + this.share.sharingId + '/records'
      }
      this.$router.push({
        path: pathName,
        query: query
      })
    },
    moveToOnBoarding() {
      if (this.$redirectToPatientAppFlag) {
        return (window.location.href = `${PATIENT_APP_URL}/login?form=register&inviteToken=${
          this.share && this.share.token
        }`)
      }
      // make sure this is a share token
      if (this.share && this.share.token) {
        this.redirectToOnboarding({
          url: onboardingUrl,
          token: this.share.token,
          type: 'share'
        })
      }
    }
  },
  async mounted() {
    const sharedID = this.$route.params.shareId
    if (sharedID) {
      this.loading = true
      await this.shareDetailWithIdAndToken(sharedID)
      this.loading = false
    }
  }
}
</script>

<style lang="stylus" scoped>
.view-health-records
 font-size: 18px
 font-weight: 600
 letter-spacing: normal
 line-height:2rem
 color: #161616

.account-create
 font-size: 16px
 font-weight: 400
 letter-spacing: normal
 line-height:2rem
 color: #161616

.no-access
 font-size: 25px
 font-weight: 600
 letter-spacing: normal
 line-height:2rem
 color: #161616
 margin: 20px 0

.btn-wrapper
  display flex
  flex-direction row
  justify-content space-between

.btn-margins
  margin 10px

@media only screen and (max-width: 561px)
  .btn-wrapper
   flex-direction column
</style>
